import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function FeaturedSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">推荐漫画</h2>
          <p className="text-foreground-500 text-sm max-w-md mx-auto">精选热门韩漫，高分好评不容错过</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="group relative aspect-[3/4] rounded-xl overflow-hidden cursor-pointer"
            >
              <img
                src={comic.coverImage}
                alt={comic.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent"></div>

              <div className="absolute top-3 left-3">
                <span className="inline-block px-2.5 py-1 bg-accent-500 text-foreground-950 text-xs font-medium rounded-full">
                  {comic.category}
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-background-50 font-heading text-lg mb-1.5">{comic.title}</h3>
                <div className="flex items-center gap-3 text-background-50/80 text-xs">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-400 text-xs"></i>
                    {comic.rating}
                  </span>
                  <span>{comic.author}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-xs"></i>
                    {comic.totalViews}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}